<template>
  <tr>
    <td class="middle text-center p-0">{{ index + 1 }}.</td>

    <w-table-cell class="middle p-0" :model="item.gender">
      <w-radio-list class="ml-2" :model="item.gender" :values="genders" />
    </w-table-cell>

    <w-table-cell class="p-0" :model="item.firstName">
      <w-input title-attribute="Imię" :model="item.firstName" />
    </w-table-cell>

    <w-table-cell class="p-0" :model="item.lastName">
      <w-input title-attribute="Nazwisko" :model="item.lastName" />
    </w-table-cell>

    <w-table-cell class="p-0" :model="item.scholarshipName">
      <w-input title-attribute="Nazwa szkoły" :model="item.scholarshipName" />
    </w-table-cell>

    <w-row-buttons
      class="middle p-0"
      :model="item"
      :move-up="index != 0"
      :move-down="item.$parent.$value.length - 1 !== index"
    />
  </tr>
</template>

<script>
import components from '@witkac/bootstrap4-components';
import { mapState } from 'vuex';

import { Options } from '@/enums/options.enum';

// @vuese
// Pojedynczy wiersz tabeli nauczyciele
// @Group detailsComponents
export default {
  components: {
    ...components
  },
  props: {
    // Wartość przekazana do wypełnienia pola w schemacie
    item: { type: Object, required: true },

    // Indeks
    index: { type: Number, required: true }
  },
  computed: {
    ...mapState({
      genders: state => {
        const dictionary = state.optionValue.options[Options.DICTIONARY].value;
        return dictionary && JSON.parse(dictionary).genders;
      }
    })
  }
};
</script>
